import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { blockDefaultV0Schema } from './v0';
import { blockDefaultLegacySchema } from '../legacy/schema';
import { migrateLegacyDefaultToV0 } from '../legacy/migration';

export const DefaultBlockEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: blockDefaultV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: blockDefaultLegacySchema, up: migrateLegacyDefaultToV0 }],
});

export type DefaultBlock = InferredEntity<typeof DefaultBlockEntitySchema>;
